<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div>
	<app-setup-wizard-editor></app-setup-wizard-editor>
</div>
